import { Injectable } from '@angular/core';

export interface FormatCo2eOptions {
  perPerson?: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class FormatCo2eService {
  format(
    valueInKg: number | null | undefined,
    options?: FormatCo2eOptions
  ): string {
    if (valueInKg === null || valueInKg === undefined) {
      return '';
    }
    return `${this.formatValue(valueInKg)} ${this.getUnit(valueInKg, options)}`;
  }

  formatValue(valueInKg: number | null | undefined): string {
    if (valueInKg === null || valueInKg === undefined) {
      return '';
    }

    if (this.isTons(valueInKg)) {
      return (valueInKg / 1000).toFixed(2).replace('.', ',');
    }

    return Math.round(valueInKg).toString();
  }

  getUnit(
    valueInKg: number | null | undefined,
    options?: FormatCo2eOptions
  ): string {
    const baseUnit = this.isTons(valueInKg ?? 0) ? 't CO₂e' : 'kg CO₂e';
    return options?.perPerson ? `${baseUnit}/pers` : baseUnit;
  }

  isTons(valueInKg: number): boolean {
    return Math.abs(valueInKg) >= 1000;
  }
}
